const API_BASE_URL = '/inventory-search';

export const RESUME_SEARCH_SAVED_SEARCHES_PREFERENCES_KEY = 'resume';

export const ENDPOINTS = {
  CertificationsDescriptions: `${API_BASE_URL}/resumes/certifications/descriptions`,
  CertificationsIssuingOrganizations: `${API_BASE_URL}/resumes/certifications/issuing-organizations`,
  EducationsDegrees: `${API_BASE_URL}/resumes/educations/degrees`,
  EducationsIssuingOrganizations: `${API_BASE_URL}/resumes/educations/issuing-organizations`,
  EducationsMajors: `${API_BASE_URL}/resumes/educations/majors`,
  EmailSubscriptionStatuses: `${API_BASE_URL}/resumes/email-subscription-statuses`,
  EmailValidations: `${API_BASE_URL}/resumes/email-validations`,
  Industries: `${API_BASE_URL}/resumes/industries`,
  JobFunctions: `${API_BASE_URL}/resumes/job-functions`,
  Keywords: `${API_BASE_URL}/resumes/keywords`,
  Languages: `${API_BASE_URL}/resumes/languages`,
  LastActivityType: `${API_BASE_URL}/resumes/last-activity-type`,
  LocationsCities: `${API_BASE_URL}/resumes/locations/cities`,
  LocationsStates: `${API_BASE_URL}/resumes/locations/states`,
  Names: `${API_BASE_URL}/resumes/names`,
  OpenToRelocation: `${API_BASE_URL}/datasheets/open-to-relocation`,
  ProfessionalAssociationsDescriptions: `${API_BASE_URL}/resumes/professional-associations/descriptions`,
  ProfessionalAssociationsIssuingOrganizations: `${API_BASE_URL}/resumes/professional-associations/issuing-organizations`,
  ProfessionalExperiencesCompanies: `${API_BASE_URL}/resumes/professional-experiences/companies`,
  ProfessionalExperiencesTitles: `${API_BASE_URL}/resumes/professional-experiences/titles`,
  ReasonsForLooking: `${API_BASE_URL}/datasheets/reasons-for-looking`,
  Recruiters: `${API_BASE_URL}/resumes/recruiters`,
  RelocationDestinations: `${API_BASE_URL}/datasheets/relocation-destinations`,
  Resumes: `${API_BASE_URL}/resumes`,
  SalaryTypes: `${API_BASE_URL}/datasheets/salary-types`,
  Skills: `${API_BASE_URL}/resumes/skills`,
  Specialties: `${API_BASE_URL}/resumes/specialties`,
  Statuses: `${API_BASE_URL}/datasheets/statuses`,
  Subspecialties: `${API_BASE_URL}/resumes/subspecialties`,
  Teams: `${API_BASE_URL}/resumes/teams`,
  TimesToStart: `${API_BASE_URL}/datasheets/times-to-start`,
  Types: `${API_BASE_URL}/datasheets/types`,
  WorkPreferences: `${API_BASE_URL}/datasheets/work-preferences`
};

export const RESUME_SORT_OPTIONS = [
  { id: 'best_match', order: [{ field: 'score', sort: 'DESC' }] },
  { id: 'name_asc', order: [{ field: 'basics.fullName', sort: 'ASC' }] },
  { id: 'name_desc', order: [{ field: 'basics.fullName', sort: 'DESC' }] },
  { id: 'newest', order: [{ field: 'createdAt', sort: 'DESC' }] },
  { id: 'oldest', order: [{ field: 'createdAt', sort: 'ASC' }] }
];

export const DEFAULT_RESUME_SORT_ID = 'best_match';

export const getResumeSortOrder = sortId =>
  RESUME_SORT_OPTIONS.find(option => option.id === sortId)?.order ?? RESUME_SORT_OPTIONS[0].order;

export const SLOT_PROPS = {
  collapsiblePanel: {
    contentStyles: { overflowY: 'auto' },
    togglerTop: 8
  }
};
